import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PlaybooksViewAllButton({
  actions
}) {
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: actions.showAllPlaybooks,
    "data-test-id": "playbook-card-view-all-playbooks",
    paddingBlockStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPlaybooks.playbookCard.viewAllPlaybooks"
    })
  });
}